


































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {MixinMember} from '@/components/mixins/MixinMember'
import DeliveryUfRequest from '@/model/request/DeliveryUfRequest'
import {ItrackCollection} from '@/helpers'
import {IResource, ObjectCollection} from 'simpli-web-sdk'

@Component
export default class FilterDeliveryUf extends Mixins(MixinMember) {
  @Prop({type: Object, required: true}) value!: DeliveryUfRequest

  async mounted( ) {
    await this.value.allCentroDeCusto.query()
    await this.value.allTipoInsumo.query()
  }

  get valueComputed() {
    return this.value
  }

  set valueComputed(val) {
    this.$emit('input', val)
  }

  formatSigla() {
    if (this.value.sigla) {
      this.value.sigla = this.value.sigla.toUpperCase()
    }
  }
}
